/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface Props {
  idLeadCorretor: string;
  idEtapaLead: string;
  idSubEtapaLead: string;
}
export function usePostAlterarEtapaSubetapa() {
  const putData = async (props: Props) => {
    const POST_ALTERAR = `${leadsWebEnviroment}/commom/leads/alterar-etapa-subetapa/v1/${props.idLeadCorretor}`;
    const { data } = await instance.put(POST_ALTERAR, {
      idEtapaLead: props.idEtapaLead,
      idSubEtapaLead: props.idSubEtapaLead,
    });
    return data;
  };

  const mutation = useMutation({
    mutationFn: putData,
    onSuccess: () => {},
    onError: () => {},
  });

  return mutation;
}
